import { useMemo } from 'react';
import { useParams } from 'react-router';

export function useGetLangFromUrl() {
  const { lang: langFromUrl } = useParams();
  const langFromLS = localStorage.getItem('language');

  const lang = useMemo(() => {
    if (langFromLS === 'en') {
      return '';
    }
    return langFromUrl || langFromLS;
  }, [langFromLS, langFromUrl]);

  return lang;
}
